<template lang="pug">
  router-link( :to="path" :current="regex ? regex.test($route.path) : $route.path === path" )
    slot
</template>

<script>
  export default {
    props: ['path', 'regex']
  }
</script>